<template>
	<div class="container-fluid" id="profile_section">
		<div v-if="user_level < 50">
			<h5 class="text-danger text-center mt-5">Access Denied!</h5>
		</div>

		<div v-else>
			<div class="row gold text-center">
				<div class="col-md-6 col-12">
					<h2>
						<i class="fas fa-users"></i> <span v-text="this.$route.meta.title"></span> (<small
							v-text="totalRows"
						></small
						>)
					</h2>
				</div>
				<div v-if="user_level >= 90" class="col-md-6 col-12">
					<button type="button" class="btn btn-sm btn-outline-secondary" @click="addMember">
						<i class="fas fa-user-plus"></i> Add New
						<span v-text="this.$route.meta.title"></span>
					</button>

					<button type="button" class="btn btn-sm btn-outline-secondary" @click="downloadAsCSV">
						<i class="fas fa-download"></i> Download members
					</button>
				</div>
			</div>

			<!-- dashboard modal
		<b-modal id="modal-dashboard" :title="modal_dashboard.title" ref="modal-dashboard" size="xl" hide-footer>
				
		</b-modal>
		-->

			<!-- edit user profile modal-->
			<b-modal id="modal-profile" :title="modal.title" ref="modal-profile" hide-footer>
				<b-form @submit="submitMemberForm($event)">
					<b-form-group description="Members Status">
						<b-form-select
							v-model="modal.member.status"
							:options="options.statuses"
							@change="validate(modal.member)"
						></b-form-select>
					</b-form-group>

					<b-form-group description="Members Status">
						<b-form-select
							v-model="modal.member.level"
							:options="options.levels"
							@change="validate(modal.member)"
						></b-form-select>
					</b-form-group>

					<b-form-group v-if="modal.member.level >= 30">
						<div class="d-flex" style="gap: 6px">
							<label for="coach" class="mb-0">Coach?</label>
							<b-form-checkbox id="coach" v-model="modal.member.is_coach" switch></b-form-checkbox>
						</div>
					</b-form-group>

					<b-form-group description="Members First name">
						<small class="text-danger" v-if="modal.member.first_name === ''"
							>Enter a First name</small
						>
						<b-form-input
							v-model="modal.member.first_name"
							type="text"
							required
							placeholder="Enter First name"
							@change="validate(modal.member)"
						></b-form-input>
					</b-form-group>

					<b-form-group description="Members Last name">
						<small class="text-danger" v-if="modal.member.last_name === ''"
							>Enter a Last name</small
						>
						<b-form-input
							v-model="modal.member.last_name"
							type="text"
							required
							placeholder="Enter Last name"
							@change="validate(modal.member)"
						></b-form-input>
					</b-form-group>

					<b-form-group description="User/Screen Name">
						<small class="text-danger" v-if="modal.member.last_name === ''"
							>Enter a User name</small
						>
						<b-form-input
							v-model="modal.member.user_name"
							type="text"
							required
							placeholder="Enter user name"
							@change="validate(modal.member)"
						></b-form-input>
					</b-form-group>

					<b-form-group description="Enter a unique Email address">
						<small class="text-danger" v-if="validEmail(modal.member.email) == 0"
							>Enter an Email</small
						>
						<b-form-input
							v-model="modal.member.email"
							type="email"
							required
							placeholder="Enter email"
							@change="validate(modal.member)"
						></b-form-input>
					</b-form-group>

					<b-form-group description="* Phone is Optional">
						<b-form-input
							v-model="modal.member.phone"
							type="text"
							placeholder="Enter phone"
							@change="validate(modal.member)"
						></b-form-input>
					</b-form-group>

					<p><small class="text-danger" v-text="modal.errors.process"></small></p>
					<div class="row">
						<div class="col text-left">
							<b-button type="submit" variant="success" :disabled="modal.submitDisabled"
								>Submit</b-button
							>
						</div>
						<div class="col text-right">
							<b-button size="sm" @click="confirmBox" name="delete" variant="outline-danger"
								>Delete</b-button
							>
						</div>
					</div>
				</b-form>

				<data-streams :profileid="modal.member.session_id" />
			</b-modal>

			<div class="row" id="members_wrap">
				<div class="col-md-6 my-1">
					<b-form-group class="mb-0">
						<b-input-group size="sm">
							<b-form-input
								id="filter-input"
								v-model="filter"
								type="search"
								placeholder="Search Members"
							></b-form-input>

							<b-input-group-append>
								<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</div>

				<div class="col-md-3 col-5 my-1">
					<b-form-group class="mb-0">
						<b-form-select
							id="per-page-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
						></b-form-select>
					</b-form-group>
				</div>

				<div class="col-md-3 col-7 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>

				<div class="col-12">
					<b-table
						bordered
						responsive="md"
						:items="members"
						:busy="isBusy"
						:fields="fields"
						:filter="filter"
						:filter-included-fields="filterOn"
						@filtered="onFiltered"
						:current-page="currentPage"
						:per-page="perPage"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						sort-icon-left
						class="small"
						show-empty
					>
						<template v-slot:table-busy>
							<div class="text-center my-2 p-2">
								<b-spinner class="align-middle"></b-spinner>
								<br />
								<strong>Loading...</strong>
							</div>
						</template>

						<template v-slot:cell(actions)="data">
							<b-dropdown size="sm" class="" toggle-class="text-decoration-none" no-caret>
								<template #button-content>
									<span v-if="data.item.alerts.total > 0" class="mr-1">
										<i class="fas fa-bell text-danger"></i>
									</span>
									<span v-else>
										<i class="fas fa-angle-down gold"></i>
									</span>
								</template>

								<b-dropdown-item>
									<router-link :to="'/profile_report/' + data.item.id" class="gold">
										View <span v-text="data.item.first_name"></span>'s Report
									</router-link>
								</b-dropdown-item>

								<b-dropdown-item v-if="user_level >= 90">
									<a href="#" @click="showMuseForm($event, data.item)" class="gold">
										Upload <span v-text="data.item.first_name"></span>'s MUSE .csv data
									</a>
								</b-dropdown-item>

								<b-dropdown-item v-if="user_level >= 90">
									<div v-if="parseInt(user_level) >= parseInt(data.item.level)">
										<a href="#" @click="editMember($event, data.item)" class="gold">
											Edit <span v-text="data.item.first_name"></span>
										</a>
									</div>
									<div v-else>
										<small>No Edit permissions</small>
									</div>
								</b-dropdown-item>
							</b-dropdown>

							<div
								v-if="data.item.meta.muse_show_upload == 1 && user_level >= 90"
								class="border p-2 m-1 text-center"
							>
								<h6>MUSE CSV Upload</h6>
								<div v-if="muse.processing == 0">
									<b-form-file
										v-model="muse.file"
										ref="file"
										name="file"
										accept=".csv, .CSV"
										size="sm"
									></b-form-file>

									<div v-if="muse.file !== null" class="mt-3">
										<b-button
											type="button"
											@click="museUpload($event, data.item)"
											variant="primary"
											>Upload</b-button
										>
									</div>
								</div>
								<div v-if="muse.processing == 1">
									Uploading <i class="fas fa-spinner fa-spin"></i>
								</div>
							</div>
							<div v-if="data.item.meta.muse_message">
								<small
									v-text="data.item.meta.muse_message"
									:class="data.item.meta.muse_upload_class"
								></small>
							</div>
						</template>

						<template v-slot:cell(user_score)="data">
							<router-link
								v-if="data.item.user_score > 0"
								:to="'/dashboard/' + data.item.id"
								class="d-flex"
							>
								<b-progress
									:value="data.item.user_score"
									max="100"
									show-value
									:variant="progressColour(data.item.user_score)"
									style="height: 20px; width: 150px"
									class="float-right"
								></b-progress>
							</router-link>

							<small
								v-for="(val, index) in data.item.score_data.type"
								:key="'score_' + index"
							>
								- <small v-text="index"></small>: <span v-text="val"></span>
							</small>
						</template>

						<template v-slot:cell(status)="data">
							<span v-text="arrayElmGet(options.statuses, data.item.status)"></span>
						</template>

						<template v-slot:cell(level)="data">
							<span v-text="arrayElmGet(options.levels, data.item.level)"></span>
						</template>

						<template v-slot:cell(last_session)="data">
							<span v-text="data.item.last_session.date" class="mr-1"></span>
							<span v-text="data.item.last_session.time"></span>
						</template>
					</b-table>
				</div>

				<div class="col-12 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>

				<div class="row small">
					<div class="col-12">
						* Focus Score is calculated from the past 7 days using (feelings log & meditation
						data).
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import DataStreams from '../components/DataStreams.vue';

export default {
	name: 'Members',
	components: {
		DataStreams,
	},
	props: {},
	data() {
		return {
			modal: {
				title: '',
				submitDisabled: true,
				member: {},
				errors: {
					process: '',
				},
			},
			modal_dashboard: {
				title: '',
				member: {},
			},
			modal_member_default: {
				id: 0,
				first_name: '',
				last_name: '',
				user_name: '',
				email: '',
				phone: '',
				status: 1,
				level: 20,
				is_coach: false,
			},
			options: {
				levels: [
					{ value: 0, text: 'Pending' },
					{ value: 20, text: 'Member' },
					{ value: 30, text: 'Team Coach' },
					{ value: 50, text: 'Editor' },
					{ value: 90, text: 'Admin' },
				],
				statuses: [
					{ value: 0, text: 'Closed' },
					{ value: 1, text: 'Active' },
				],
			},
			errors: {},
			members: null,
			fields: [
				{ key: 'actions', sortable: false, label: '', class: '' },
				{ key: 'user_score', sortable: true, label: 'Weekly Score', class: 'score_width' },
				{ key: 'first_name', sortable: true, label: 'First Name', class: '' },
				{ key: 'last_name', sortable: true, label: 'Last Name', class: '' },
				{ key: 'user_name', sortable: true, label: 'User/Screen Name', class: '' },
				{ key: 'email', sortable: true, label: 'Email', class: '' },
				{ key: 'phone', sortable: true, label: 'Phone', class: '' },
				{ key: 'last_session', sortable: true, label: 'Last Login', class: 'last_session' },
				{ key: 'timestamp', sortable: true, label: 'Date sort', class: '' },
				{ key: 'status', sortable: true, label: 'Status', class: '' },
				{ key: 'level', sortable: true, label: 'Level', class: '' },
				{ key: 'timezoneOffsetH', sortable: true, label: 'TZ', class: '' },
				{ key: 'id', sortable: true, label: 'User ID', class: '' },
			],
			isBusy: true,
			sortBy: 'timestamp',
			sortDirection: 'desc',
			sortDesc: true,
			totalRows: 0,
			currentPage: 1,
			perPage: 50,
			pageOptions: [
				{ value: 50, text: 'Num to Show' },
				25,
				50,
				100,
				{ value: 500, text: 'All' },
			],
			filter: null,
			filterOn: [],
			muse: {
				file: null,
				processing: 0,
				message: '',
			},
		};
	},
	methods: {
		arrayElmGet(obj, value) {
			if (parseInt(value) === 99) {
				return 'WebMaster';
			}
			const entries = Object.entries(obj);
			for (const v of entries) {
				if (parseInt(v[1].value) === parseInt(value)) {
					return v[1].text;
				}
			}
			return null;
		},

    downloadAsCSV() {
      const params = {
        token: this.$store.state.session_id
      }

      this.loading = true
      axios({
        url: `${this.$store.state.api_url}membersCSV`,
        params,
      })
        .then((response) => {
          const options = {type: "text/csv;charset=utf-8"}
          const url = window.URL.createObjectURL(
            new Blob([response.data], options)
          )
          const link = document.createElement('a')
          link.href = url
          const filename = `members.csv`
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false
        })
    }
    ,

		addMember() {
			this.modal.title = 'Add Member';
			this.modal.member = this.modal_member_default;
			this.modal.errors.process = '';
			this.$bvModal.show('modal-profile');
			this.validate(this.modal.member);
		},
		editMember(e, member) {
			this.modal.title = 'Edit Profile';
			this.modal.member = member;
			this.modal.errors.process = '';
			this.$bvModal.show('modal-profile');
			this.validate(this.modal.member);
		},
		checkPassword() {
			if (this.password != this.password_confirm) {
				this.errors.password = 'Passwords do not match!';
				return false;
			} else {
				this.errors.password = '';
				return true;
			}
		},
		checkEmail(value) {
			if (!this.validEmail(value)) {
				this.errors.email = 'Email is In-Valid';
				this.disableSubmit = false;
				this.btn_update_class = 'btn-secondary';
				this.btn_update_icon = 'fa-pen';
				return false;
			} else {
				this.errors.email = '';
				return true;
			}
		},
		confirmBox() {
			this.$bvModal
				.msgBoxConfirm('Are you sure? All data will be lost...')
				.then((value) => {
					if (value == true) {
						this.deleteMemberForm();
					} else {
						this.$bvModal.hide('modal-profile');
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		deleteMemberForm() {
			let _this = this;
			_this.modal.submitDisabled = true;
			_this.modal.errors.process = 'Removing Data ...';
			let params = new URLSearchParams();
			params.append('session_id', _this.$store.state.session_id);
			params.append('user_id', _this.modal.member.id);

			axios({
				url: _this.$store.state.api_url + 'userDelete',
				params: params,
			})
				.then(function (response) {
					_this.modal.errors.process = response.data.message;

					if (response.data.status == 1) {
						_this.members = _this.members.filter(function (obj) {
							return obj.id !== response.data.user_id;
						});
						_this.modal.member = _this.modal_member_default;
						_this.$bvModal.hide('modal-profile');
					}
				})
				.catch(function () {});
		},
		displayOptionsSet() {
			console.log('displayOptionsSet:' + this.user_level);
			if (this.user_level == 99) {
				this.options.levels.push({ value: 99, text: 'WebMaster' });
			} else if (this.user_level == 50) {
				this.$route.meta.title = 'Team Members';
				document.title = this.$route.meta.title + ' - iAMconnected App';
			}
		},
		getMembers() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);

			var _URL = _this.$store.state.api_url + 'membersGet';

			axios({
				url: _URL,
				params: params,
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						_this.members = response.data.members;
					} else {
						_this.members = null;
					}
					_this.totalRows = _this.members.length;
				})
				.catch(function () {
					console.log('Error: boardDataGet.');
				});
		},
		museUpload(e, member) {
			this.muse.processing = 1;
			let _this = this;

			let formData = new FormData();
			formData.append('file', this.muse.file);
			formData.append('token', _this.$store.state.session_id);
			formData.append('user_token', member.session_id);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'museCsvUpload',
				headers: { 'Content-Type': 'multipart/form-data' },
				data: formData,
			})
				.then(function (response) {
					member.meta.muse_message = response.data.message;
					member.meta.muse_upload_class = response.data.upload_class;

					_this.muse.processing = 0;
					_this.muse.file = null;
					member.meta.muse_show_upload = 0;
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		progressColour(value) {
			var colour = '';
			if (value >= 70) {
				colour = 'success';
			} else if (value >= 50) {
				colour = 'warning';
			} else if (value > 0) {
				colour = 'danger';
			}
			return colour;
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		setDisable() {
			console.log('setDisable');
			this.disableSubmit = true;
			this.btn_update_class = 'btn-success';
			this.btn_update_icon = 'fa-hand-point-down';
		},
		showMuseForm(e, member) {
			e.preventDefault();

			const m = Object.values(this.members);
			for (const key of m) {
				key.meta.muse_show_upload = 0;
				key.meta.muse_message = '';
				key.meta.muse_upload_class = '';
			}

			this.muse.file = null;

			member.meta.muse_show_upload = 1;
			return false;
		},
		streamClassChange(item, status) {
			if (item.value != item.api_user_id) {
				item.class = 'btn-primary';
				item.icon = 'far fa-hand-point-down';
			} else if (status == 1) {
				item.class = 'text-success';
				item.icon = 'fas fa-check';
			} else if (status == -1) {
				item.class = 'text-danger';
				item.icon = 'fas fa-times';
			} else {
				item.class = '';
				item.icon = '';
			}
		},
		submitMemberForm(e) {
			e.preventDefault();
			this.validate(this.modal.member);

			this.modal.errors.process = 'Processing...';

			if (this.modal.member.level < 30) {
				this.modal.member.is_coach = false
			}

			const params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('id', this.modal.member.id);
			params.append('first_name', this.modal.member.first_name);
			params.append('last_name', this.modal.member.last_name);
			params.append('user_name', this.modal.member.user_name);
			params.append('email', this.modal.member.email);
			params.append('phone', this.modal.member.phone);
			params.append('status', this.modal.member.status);
			params.append('level', this.modal.member.level);
			params.append('is_coach', this.modal.member.is_coach);

			axios({
				url: this.$store.state.api_url + 'userAddEdit',
				params: params,
			})
				.then((response) => {
					this.modal.errors.profile = response.data.message;
					if (response.data.status == 1) {
						this.modal.member = this.modal_member_default;
						if (response.data.member !== null) {
							console.log(response.data.type);
							if (response.data.type === 'add') {
								this.members.unshift(response.data.member);
							} else {
								this.members.find((obj) => {
									if (obj.id === this.modal.member.id) {
										obj = response.data.member;
									}
								});
							}
						}
						this.$bvModal.hide('modal-profile');
					} else {
						this.modal.errors.process = response.data.message;
					}
				})
				.catch(function () {});
		},
		/*
		toggleDashboard(e, member){
			this.modal_dashboard.title = 'View '+ member.user_name+'\'s Dashboard Data';
			this.modal_dashboard.member = member;
			this.$bvModal.show('modal-dashboard');
		},
		*/
		UpdateStreamSettings(stream) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('session_id', this.$store.state.session_id);
			params.append('stream_id', stream.user_data_id);
			params.append('value', stream.api_user_id);
			axios({
				url: _this.$store.state.api_url + 'dataStreamSet',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.streamClassChange(stream, 1);
					} else {
						_this.streamClassChange(stream, -1);
					}
				})
				.catch(function () {});
		},
		validEmail(email) {
			var re =
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			var val = re.test(email);
			return val;
		},
		validate(member) {
			var valid = true;
			if (member.status === '' || member.status === 'null') {
				valid = false;
			}
			if (member.level === '' || member.level === 'null') {
				valid = false;
			}
			if (member.first_name === '' || member.last_name === '' || member.user_name === '') {
				valid = false;
			}
			if (this.validEmail(member.email) === 0) {
				valid = false;
			}

			if (valid == true) {
				this.modal.submitDisabled = false;
				return false;
			} else {
				this.modal.submitDisabled = true;
				return true;
			}
		},
	},
	computed: {
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
		active_profile() {
			return this.$store.getters.profileGet;
		},
		user_level() {
			return this.active_profile.level;
		},
	},
	created() {},
	mounted() {
		this.displayOptionsSet();
		this.getMembers();
	},
	watch: {},
};
</script>

<style scoped>
th.score_width {
	min-width: 180px !important;
}
th.last_session {
	min-width: 160px !important;
}
</style>
